export default __webpack_public_path__ + "static/media/disc-icon.4ecc8fe7.svg";